import React from 'react';
import { XIcon, CheckIcon } from 'lucide-react';
import { beforeItems, afterItems } from '../data/content';
import { SectionCTA } from './SectionCTA';
export function BeforeAfter() {
  return <section className="bg-ink px-4 py-16 text-white" aria-labelledby="ba-title" data-id="element-18" data-mp="3ogauvp93qz4s">
      <div className="mx-auto max-w-5xl" data-id="element-19" data-mp="3sh344ihz5412">
        <h2 id="ba-title" className="text-center font-serif text-[1.9rem] font-bold leading-tight sm:text-5xl" data-id="element-20" data-mp="3sg1qq7dhk5g6">
          From a surgeon who studies endlessly…
          <span className="mt-2 block italic text-gold" data-id="element-21" data-mp="3jgerns88bbqa">…to a surgeon who has a system for every case.</span>
        </h2>

        <div className="mx-auto mt-8 max-w-2xl space-y-3 text-center text-lg leading-relaxed text-white/75" data-id="element-22" data-mp="34sjykaqb75co">
          <p data-id="element-23" data-mp="39rn2frujz5j2">Rhinoplasty requires hundreds of individual observations and decisions.</p>
          <p data-id="element-24" data-mp="2vqu7x7494afy">
            The problem isn’t always a lack of knowledge. Sometimes the problem is having{' '}
            <strong className="text-white" data-id="element-25" data-mp="30ovnhi2gxrmo">too much information</strong> — without a structured system for organizing it.
          </p>
        </div>

        <div className="mt-10 grid gap-5 md:grid-cols-2" data-id="element-26" data-mp="x6emq93p5g89">
          <div className="rounded-3xl border border-white/10 bg-ink-soft p-6 sm:p-8" data-id="element-27" data-mp="t270qjomiedq">
            <p className="inline-block rounded-full bg-red-500/15 px-4 py-1.5 text-sm font-extrabold uppercase tracking-wider text-red-300" data-id="element-28" data-mp="171os96tb05qs">
              Before
            </p>
            <h3 className="mt-4 font-serif text-2xl font-bold" data-id="element-29" data-mp="edj74iyc8eqf">Without a system</h3>
            <ul className="mt-5 space-y-4" data-id="element-30" data-mp="9f9a02t1z426">
              {beforeItems.map(item => <li key={item} className="flex gap-3 text-base leading-snug text-white/75" data-id="element-31" data-mp="o3vndyz4dlqr">
                  <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-red-500/20" data-id="element-32" data-mp="o5oz3solaw5m">
                    <XIcon className="h-4 w-4 text-red-300" aria-hidden="true" data-id="element-33" data-mp="3rsp676cicb49" />
                  </span>
                  {item}
                </li>)}
            </ul>
          </div>

          <div className="rounded-3xl border-2 border-gold bg-cream p-6 text-ink sm:p-8" data-id="element-34" data-mp="1qqzke7wtu5dp">
            <p className="inline-block rounded-full bg-gold px-4 py-1.5 text-sm font-extrabold uppercase tracking-wider text-ink" data-id="element-35" data-mp="1vpkio1siqezi">
              After
            </p>
            <h3 className="mt-4 font-serif text-2xl font-bold" data-id="element-36" data-mp="20hc8ga3uogol">With the Blueprint</h3>
            <ul className="mt-5 space-y-4" data-id="element-37" data-mp="24hmhjvmxvn7o">
              {afterItems.map(item => <li key={item} className="flex gap-3 text-base font-medium leading-snug" data-id="element-38" data-mp="17t6o3ogpktpa">
                  <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-ink" data-id="element-39" data-mp="1crzrgo2a74bq">
                    <CheckIcon className="h-4 w-4 text-gold" aria-hidden="true" data-id="element-40" data-mp="1gr094390w0x5" />
                  </span>
                  {item}
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mx-auto mt-10 max-w-2xl text-center" data-id="element-41" data-mp="2s7gued79dbrx">
          <p className="text-lg text-white/75" data-id="element-42" data-mp="2x5s1wha2za6z">
            That is why <strong className="text-gold" data-id="element-43" data-mp="37aql0r8n45s7">Sculptor’s Operating Blueprint™</strong> was created — a practical
            framework to move from:
          </p>
          <p className="mt-4 font-serif text-xl font-bold tracking-wide text-gold-light sm:text-2xl" data-id="element-44" data-mp="32c6yaom82pys">
            CASE → ANALYSIS → OBJECTIVES → PLAN → REVIEW
          </p>
          <p className="mt-3 text-white/60" data-id="element-45" data-mp="2tk4z0tnw3fq3">with a repeatable structure you can consult whenever you need it.</p>
        </div>

        <SectionCTA label="Yes, I want a system for every case" tone="dark" data-id="element-46" data-mp="2oltripl2hhb1" />
      </div>
    </section>;
}